<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M24 7A17 17 0 117 24 17 17 0 0124 7m0-3a20 20 0 1020 20A20 20 0 0024 4z"/><path d="M24 16l1.69 3.39.71 1.41 1.56.22 3.76.53L29 24.16l-1.15 1.11.29 1.58.69 3.77-3.4-1.79-1.43-.76-1.41.79-3.24 1.8.52-3.66.24-1.57-1.11-1.1-2.85-2.63 3.93-.7 1.49-.26.67-1.36L24 16m0-4.24a2 2 0 00-1.79 1.11l-2.62 5.23-5.9 1a2 2 0 00-1 3.43l4.27 4-.96 5.69a2 2 0 002 2.31 2 2 0 001-.26l5-2.79 5.22 2.75a1.93 1.93 0 00.94.24 2 2 0 002-2.37l-1.06-5.79 4.19-4.08a2 2 0 00-1.11-3.42L28.34 18l-2.59-5.18A2 2 0 0024 11.71z"/></svg>